import { ShopInsuranceFilters } from '@/components/ShopInsuranceFilters';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

interface ShopInsuranceFiltersSidebarProps {
  selectedEligibilityFilters: string[];
  setSelectedEligibilityFilters: (filters: string[]) => void;
  showEligibilityFilter: boolean;
  eligibilityCounts: {
    eligible: number;
    unsure: number;
    ineligible: number;
  };
  selectedFeatureBenefitsFilters: string[];
  setSelectedFeatureBenefitsFilters: (filters: string[]) => void;
}

export function ShopInsuranceFiltersSidebar(props: ShopInsuranceFiltersSidebarProps) {
  return (
    <>
      {/* Mobile Popover */}
      <Popover>
        <PopoverTrigger asChild>
          <Button
            className="flex w-full lg:hidden"
            variant="outline"
          >
            Filters
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-80">
          <ShopInsuranceFilters {...props} />
        </PopoverContent>
      </Popover>

      {/* Desktop Sidebar */}
      <div className="sticky top-0 hidden min-h-64 w-full basis-96 lg:block lg:max-h-[calc(100vh-320px)] lg:overflow-y-auto lg:pb-6">
        <ShopInsuranceFilters {...props} />
      </div>
    </>
  );
}
